'use client';

import { useEffect } from 'react';
import { captureException } from '@sentry/nextjs';
import { ErrorScreen } from '@/components/system/ErrorScreen';

function isStaleActionError(error: Error) {
  return (
    error.name === 'UnrecognizedActionError' ||
    error.message?.includes('was not found on the server')
  );
}

export default function StorefrontError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (isStaleActionError(error)) {
      // Stale client after deployment — hard reload fetches the new bundle and resolves the error.
      window.location.reload();
      return;
    }
    captureException(error);
  }, [error]);

  return <ErrorScreen onRetry={reset} />;
}
